import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { BsEyeFill } from 'react-icons/bs';
import { Button } from 'ypf-pas-general-ui-components';

import BoxesWithText from '../BoxesWithText/BoxesWithText';
import './CustomAccordion.scss';
import CustomCheck from '../CustomCheck/CustomCheck';
import colors from '../../../styles/colors.module.scss';
import useDetailsEventsModal from '../../../hooks/useDetailsEventsModal';

const LeftContentAccordion = ({
  ubicationName,
  positionName,
  lineName,
  unitMeasure,
  isChecked,
  onChange,
  equipmentName,
  typeEvent,
  id,
  accordionData,
  hasTechnicalLocations,
  isTemplate,
  requestData
}) => {
  const {
    handleShowDetailsEventsModal,
    handleHasTechnicalLocations,
    handleOperations,
    handleTitleModal
  } = useDetailsEventsModal();

  const handleSetTitleModal = () => {
    handleTitleModal({
      title: `${ubicationName}${'  '}${typeEvent}${'  '}${equipmentName}`
    });
  };
  const isServiceFinished = accordionData?.finalizada;
  const activeDescription =
    accordionData?.descripcionActivo ||
    accordionData?.ubicacionTecnica?.descripcionActivo ||
    accordionData?.ubication?.active?.nombre;

  return (
    <div className="left-content-accordion">
      {ubicationName ? (
        <>
          <CustomCheck
            disabled={isServiceFinished}
            id={id}
            isChecked={isChecked && !isServiceFinished}
            onChange={onChange}
          />
          <div>
            <p>Ubicación {`${isServiceFinished ? '(Serv. Finalizado)' : ''}`}</p>
            <div className="d-flex left-content-accordion-info-container">
              <div>
                <div className="container-title">
                  <div>{ubicationName}</div>
                  {activeDescription && <div>{activeDescription}</div>}
                  <div>{typeEvent}</div>
                  <div>{equipmentName}</div>
                </div>

                {!isTemplate &&
                  handleHasTechnicalLocations({
                    headData: { tieneUbicacionesTecnicas: hasTechnicalLocations }
                  }) && (
                    <Button
                      className="eye-button"
                      colorIcon="primary"
                      icon={BsEyeFill}
                      onClick={() => {
                        handleShowDetailsEventsModal({ showModal: true });
                        handleSetTitleModal();
                        handleOperations({
                          ubicationsData: accordionData,
                          requestData
                        });
                      }}
                      sizeIcon="20px"
                      type="button"
                      widthButton="40px"
                    />
                  )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <Col className="d-flex justify-content-between" sm={12}>
          <CustomCheck id={id} isChecked={isChecked} onChange={onChange} />
          <Col
            style={{
              minWidth: '350px'
            }}
          >
            <p>Posición</p>
            <BoxesWithText
              backgroundColor={colors.light}
              className="left-content-accordion-info"
              color={colors.black}
            >
              {positionName}
            </BoxesWithText>
          </Col>
          <Col
            style={{
              minWidth: '350px'
            }}
          >
            <p>Linea</p>
            <BoxesWithText
              backgroundColor={colors.light}
              className="left-content-accordion-info"
              color={colors.black}
            >
              {lineName}
            </BoxesWithText>
          </Col>
          <Col
            // className="mx-2"
            style={{
              minWidth: '45px'
            }}
          >
            <p>UM</p>
            <BoxesWithText
              backgroundColor={colors.light}
              className="left-content-accordion-info"
              color={colors.black}
            >
              {unitMeasure}
            </BoxesWithText>
          </Col>
        </Col>
      )}
    </div>
  );
};

LeftContentAccordion.propTypes = {
  ubicationName: PropTypes.string,
  positionName: PropTypes.string,
  lineName: PropTypes.string,
  unitMeasure: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.number.isRequired,
  equipmentName: PropTypes.string,
  typeEvent: PropTypes.string,
  accordionData: PropTypes.shape({
    idsEventoPozo: PropTypes.arrayOf(PropTypes.number),
    finalizada: PropTypes.bool,
    descripcionActivo: PropTypes.string,
    ubication: PropTypes.shape({
      active: PropTypes.shape({
        nombre: PropTypes.string
      })
    }),
    ubicacionTecnica: PropTypes.shape({
      descripcionActivo: PropTypes.string
    })
  }),
  hasTechnicalLocations: PropTypes.bool.isRequired,
  isTemplate: PropTypes.bool,
  requestData: PropTypes.shape({})
};

LeftContentAccordion.defaultProps = {
  ubicationName: '',
  positionName: '',
  lineName: '',
  unitMeasure: '',
  isChecked: false,
  onChange: () => {},
  accordionData: {},
  isTemplate: false,
  requestData: {},
  equipmentName: '',
  typeEvent: ''
};

export default LeftContentAccordion;
